function injectStyle (ssrContext) {
  require("!!../../../../xiyang/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../xiyang/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4f21ffca\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../xiyang/node_modules/vue-loader/lib/selector?type=styles&index=0!./reportTop.vue")
}
var normalizeComponent = require("!../../../../xiyang/node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = null
/* template */
import __vue_template__ from "!!../../../../xiyang/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4f21ffca\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../xiyang/node_modules/vue-loader/lib/selector?type=template&index=0!./reportTop.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f21ffca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ../common/src/components/sys/reportTop.vue
// module id = null
// module chunks = 